export default {
    state: {
        open: false
    },
    mutations: {
        toggleMenu: (state) => {
            state.open = !state.open;
        }
    },
    actions: {
        toggleMenu: (context) => {
            context.commit('toggleMenu');
        }
    },
};